export default __webpack_public_path__ + "static/media/transparentLoader.ffe3e81d.gif";